var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: {
        id: "service_form_modal",
        "no-close-on-backdrop": true,
        "hide-footer": true,
      },
      on: { hidden: _vm.onServiceFormModalHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-header-buttons-container" }, [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mode === "chooseServiceType",
                      expression: "mode === 'chooseServiceType'",
                    },
                  ],
                  staticClass: "headear-placeholder",
                }),
                _c(
                  "button",
                  {
                    staticClass: "close-modal-btn mr-7",
                    attrs: { id: "service_form_modal_close_btn" },
                    on: {
                      click: function ($event) {
                        close()
                        _vm.changeMode("chooseServiceType")
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-x",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "28",
                          height: "28",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                        }),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                        }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.mode !== "chooseServiceType",
                        expression: "mode !== 'chooseServiceType'",
                      },
                    ],
                    staticClass: "bb-btn btn-success header-save-btn",
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("serviceFormModal.saveBtn")) + " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "modal-header-title-container" }, [
                _c("h2", [_vm._v(_vm._s(_vm.modalTitle))]),
              ]),
            ]
          },
        },
      ]),
    },
    [
      !_vm.isServiceTypeChoosen
        ? _c("div", { staticClass: "choose-service-type-container" }, [
            _c(
              "div",
              {
                staticClass: "service-type-card",
                on: {
                  click: function ($event) {
                    return _vm.changeMode("singleService")
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "bb-badge badge-rounded service-type-badge success-light",
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "feather feather-calendar",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("rect", {
                              attrs: {
                                x: "3",
                                y: "4",
                                width: "18",
                                height: "18",
                                rx: "2",
                                ry: "2",
                              },
                            }),
                            _c("line", {
                              attrs: { x1: "16", y1: "2", x2: "16", y2: "6" },
                            }),
                            _c("line", {
                              attrs: { x1: "8", y1: "2", x2: "8", y2: "6" },
                            }),
                            _c("line", {
                              attrs: { x1: "3", y1: "10", x2: "21", y2: "10" },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "service-card-text" }, [
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "serviceFormModal.serviceTypes.single.name"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "serviceFormModal.serviceTypes.single.description"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c("i", { staticClass: "la la-angle-right" }),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "service-type-card",
                on: {
                  click: function ($event) {
                    return _vm.changeMode("sessionService")
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "bb-badge badge-rounded service-type-badge success-light",
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "feather feather-users",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2",
                              },
                            }),
                            _c("circle", {
                              attrs: { cx: "9", cy: "7", r: "4" },
                            }),
                            _c("path", {
                              attrs: { d: "M23 21v-2a4 4 0 0 0-3-3.87" },
                            }),
                            _c("path", {
                              attrs: { d: "M16 3.13a4 4 0 0 1 0 7.75" },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "service-card-text" }, [
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "serviceFormModal.serviceTypes.session.name"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "serviceFormModal.serviceTypes.session.description"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c("i", { staticClass: "la la-angle-right" }),
              ]
            ),
          ])
        : _vm._e(),
      _vm.isServiceTypeChoosen
        ? _c("div", { staticClass: "single-service-container" }, [
            _c("div", { staticClass: "bb-card basic-info-card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h2", { staticClass: "card-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("serviceFormModal.basicInfoCard.title")) +
                      " "
                  ),
                ]),
                _c("span", { staticClass: "card-description" }, [
                  _vm._v(
                    _vm._s(_vm.$t("serviceFormModal.basicInfoCard.description"))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "form-inputs-container" }, [
                  _c("div", { staticClass: "bb-form-group" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "serviceFormModal.basicInfoCard.nameInput.label"
                          )
                        )
                      ),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.name,
                          expression: "form.fields.name",
                        },
                      ],
                      staticClass: "bb-input",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.fields.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form.fields, "name", $event.target.value)
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.name,
                            expression: "form.errors.name",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("serviceFormModal.validation.error")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.currentUser.isInLawIndustry,
                          expression: "!currentUser.isInLawIndustry",
                        },
                      ],
                      staticClass: "bb-form-group",
                    },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "serviceFormModal.basicInfoCard.typeInput.label"
                            )
                          )
                        ),
                      ]),
                      _c("BBSelect", {
                        attrs: {
                          placeholder: _vm.$t(
                            "serviceFormModal.basicInfoCard.typeInput.placeholder"
                          ),
                          options: _vm.serviceTypeOptions,
                        },
                        on: {
                          "open-change": _vm.onServiceFormDropdownOpenChange,
                        },
                        model: {
                          value: _vm.form.fields.searchEngineTypeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.fields, "searchEngineTypeId", $$v)
                          },
                          expression: "form.fields.searchEngineTypeId",
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticClass:
                            "bb-input-description service-type-input-description",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "serviceFormModal.basicInfoCard.typeInput.description"
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.errors.searchEngineTypeId,
                              expression: "form.errors.searchEngineTypeId",
                            },
                          ],
                          staticClass: "bb-invalid-feedback",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("serviceFormModal.validation.error")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "bb-form-group" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "serviceFormModal.basicInfoCard.categoryInput.label"
                          )
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.closeAvailableCategories,
                            expression: "closeAvailableCategories",
                          },
                        ],
                        staticClass: "bb-input-group category-input",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.fields.category,
                              expression: "form.fields.category",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t(
                              "serviceFormModal.basicInfoCard.categoryInput.placeholder"
                            ),
                          },
                          domProps: { value: _vm.form.fields.category },
                          on: {
                            focus: _vm.openAvailableCategories,
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.form.fields,
                                  "category",
                                  $event.target.value
                                )
                              },
                              _vm.onCategorySearch,
                            ],
                          },
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "bb-btn btn-success",
                            on: { click: _vm.toggleAvailableCategories },
                          },
                          [
                            _c("i", {
                              class: _vm.availableCategoriesArrowClass,
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.availableCategoriesVisible,
                                expression: "availableCategoriesVisible",
                              },
                            ],
                            staticClass: "available-categories-list",
                            on: {
                              wheel: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "available-categories-scroll" },
                              [
                                _vm.displayServiceCategories.length === 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "available-categories-empty",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "defaults.select.noOptionsText"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._l(
                                  _vm.displayServiceCategories,
                                  function (category) {
                                    return _c(
                                      "div",
                                      {
                                        key: category.id,
                                        staticClass:
                                          "available-categories-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setCategory(
                                              category.name
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(category.name) + " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.category,
                            expression: "form.errors.category",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("serviceFormModal.validation.error")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bb-form-group" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "serviceFormModal.basicInfoCard.descriptionInput.label"
                            )
                          )
                        ),
                      ]),
                      _c("b-form-textarea", {
                        staticClass: "bb-textarea",
                        attrs: {
                          placeholder: _vm.$t(
                            "serviceFormModal.basicInfoCard.descriptionInput.placeholder"
                          ),
                          rows: "4",
                        },
                        model: {
                          value: _vm.form.fields.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.fields, "description", $$v)
                          },
                          expression: "form.fields.description",
                        },
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.errors.description,
                              expression: "form.errors.description",
                            },
                          ],
                          staticClass: "bb-invalid-feedback",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("serviceFormModal.validation.error")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "bb-card online-booking-card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h2", { staticClass: "card-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("serviceFormModal.onlineBookingsCard.title")
                      ) +
                      " "
                  ),
                ]),
                _c("span", { staticClass: "card-description" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("serviceFormModal.onlineBookingsCard.description")
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "div",
                  { staticClass: "bb-form-group" },
                  [
                    _c("BBSwitch", {
                      attrs: {
                        label: _vm.$t(
                          "serviceFormModal.onlineBookingsCard.onlineBookingsInput.label"
                        ),
                      },
                      model: {
                        value: _vm.form.fields.onlineBookings,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.fields, "onlineBookings", $$v)
                        },
                        expression: "form.fields.onlineBookings",
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.onlineBookings,
                            expression: "form.errors.onlineBookings",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("serviceFormModal.validation.error")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "bb-card staff-card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h2", { staticClass: "card-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("serviceFormModal.staffCard.title")) +
                      " "
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("BBCheckboxGroup", {
                    attrs: {
                      options: _vm.staffOptions,
                      elementId: "staff_checkboxes",
                      allCheckedLabel: _vm.$t(
                        "serviceFormModal.staffCard.staffInput.allLabel"
                      ),
                    },
                    model: {
                      value: _vm.form.fields.calendarIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.fields, "calendarIds", $$v)
                      },
                      expression: "form.fields.calendarIds",
                    },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.calendarIds,
                          expression: "form.errors.calendarIds",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("serviceFormModal.validation.error")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm.isInSessionServiceMode
              ? _c("div", { staticClass: "bb-card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("h2", { staticClass: "card-title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("serviceFormModal.sameTimePeopleCard.title")
                          ) +
                          " "
                      ),
                    ]),
                    _c("span", { staticClass: "card-description" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "serviceFormModal.sameTimePeopleCard.description"
                          )
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "card-body" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.sameTimePeople,
                          expression: "form.fields.sameTimePeople",
                        },
                      ],
                      staticClass: "bb-input same-time-people-input",
                      attrs: { type: "number", min: "2" },
                      domProps: { value: _vm.form.fields.sameTimePeople },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.fields,
                            "sameTimePeople",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.sameTimePeople,
                            expression: "form.errors.sameTimePeople",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("serviceFormModal.validation.error")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "bb-card pricing-card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h2", { staticClass: "card-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("serviceFormModal.pricingCard.title")) +
                      " "
                  ),
                ]),
                _c("span", { staticClass: "card-description" }, [
                  _vm._v(
                    _vm._s(_vm.$t("serviceFormModal.pricingCard.description"))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "price-and-duration-details" }, [
                  _c("p", { staticClass: "card-subtitle" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("serviceFormModal.pricingCard.priceTitle")
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "price-duration-inputs" }, [
                    _c(
                      "div",
                      { staticClass: "bb-form-group" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "serviceFormModal.pricingCard.durationInput.label"
                              )
                            )
                          ),
                        ]),
                        _c("BBSelect", {
                          attrs: { options: _vm.durationOptions },
                          on: {
                            "open-change": _vm.onServiceFormDropdownOpenChange,
                          },
                          model: {
                            value: _vm.form.fields.duration,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.fields, "duration", $$v)
                            },
                            expression: "form.fields.duration",
                          },
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.errors.duration,
                                expression: "form.errors.duration",
                              },
                            ],
                            staticClass: "bb-invalid-feedback",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("serviceFormModal.validation.error")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "bb-form-group" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "serviceFormModal.pricingCard.priceTypeInput.label"
                              )
                            )
                          ),
                        ]),
                        _c("BBSelect", {
                          staticClass: "price-type-input",
                          attrs: { options: _vm.priceTypeOptions },
                          on: {
                            "open-change": _vm.onServiceFormDropdownOpenChange,
                          },
                          model: {
                            value: _vm.form.fields.priceType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.fields, "priceType", $$v)
                            },
                            expression: "form.fields.priceType",
                          },
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.errors.priceType,
                                expression: "form.errors.priceType",
                              },
                            ],
                            staticClass: "bb-invalid-feedback",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("serviceFormModal.validation.error")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.priceInputVisible,
                            expression: "priceInputVisible",
                          },
                        ],
                        staticClass: "bb-form-group",
                      },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "serviceFormModal.pricingCard.priceInput.label"
                              )
                            )
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "bb-input-group price-input" },
                          [
                            _c("span", [_vm._v("RSD")]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.fields.price,
                                  expression: "form.fields.price",
                                },
                              ],
                              attrs: { type: "number" },
                              domProps: { value: _vm.form.fields.price },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.form.fields,
                                    "price",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.errors.price,
                                expression: "form.errors.price",
                              },
                            ],
                            staticClass: "bb-invalid-feedback",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("serviceFormModal.validation.error")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "card-footer" }, [
                _c("p", { staticClass: "card-subtitle" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("serviceFormModal.pricingCard.extraTimeTitle")
                      ) +
                      " "
                  ),
                ]),
                _c("span", { staticClass: "card-subtitle-description" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "serviceFormModal.pricingCard.extraTimeDescription"
                      )
                    )
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "bb-form-group" },
                  [
                    _c("BBSwitch", {
                      attrs: {
                        label: _vm.$t(
                          "serviceFormModal.pricingCard.enableExtraTimeInput.label"
                        ),
                      },
                      model: {
                        value: _vm.form.fields.extraTimeEnabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.fields, "extraTimeEnabled", $$v)
                        },
                        expression: "form.fields.extraTimeEnabled",
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.errors.extraTimeEnabled,
                            expression: "form.errors.extraTimeEnabled",
                          },
                        ],
                        staticClass: "bb-invalid-feedback",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("serviceFormModal.validation.error")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.fields.extraTimeEnabled,
                        expression: "form.fields.extraTimeEnabled",
                      },
                    ],
                    staticClass: "break-duration-container",
                  },
                  [
                    _c("div", { staticClass: "break-duration-card" }, [
                      _c("p", { staticClass: "break-duration-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "serviceFormModal.pricingCard.extraTimeCard.title"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "span",
                        { staticClass: "break-duration-description" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "serviceFormModal.pricingCard.extraTimeCard.description"
                              )
                            )
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bb-form-group" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "serviceFormModal.pricingCard.breakDurationInput.label"
                              )
                            )
                          ),
                        ]),
                        _c("BBSelect", {
                          staticClass: "break-duration-select",
                          attrs: { options: _vm.durationOptions },
                          on: {
                            "open-change": _vm.onServiceFormDropdownOpenChange,
                          },
                          model: {
                            value: _vm.form.fields.breakDuration,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.fields, "breakDuration", $$v)
                            },
                            expression: "form.fields.breakDuration",
                          },
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.errors.breakDuration,
                                expression: "form.errors.breakDuration",
                              },
                            ],
                            staticClass: "bb-invalid-feedback",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("serviceFormModal.validation.error")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isServiceTypeChoosen,
              expression: "isServiceTypeChoosen",
            },
          ],
          staticClass: "mobile-footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "bb-btn btn-success",
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("serviceFormModal.saveBtn")) + " ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }